import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ThemeSettings from '../../../components/UI/ThemeSettings';

const ThemeSettingsPage = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-4xl mx-auto">
      {/* Header */}
      <div className="mb-6">
        <div className="flex items-center space-x-4 mb-4">
          <Link 
            to="/settings" 
            className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
          >
            <ArrowLeft className="h-5 w-5 text-gray-600 dark:text-gray-400" />
          </Link>
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
              {t('theme.pageTitle', 'Theme Settings')}
            </h1>
            <p className="text-gray-600 dark:text-gray-400">
              {t('theme.pageDescription', 'Customize the appearance and theme of your CRM interface')}
            </p>
          </div>
        </div>
      </div>

      {/* Theme Settings Component */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
        <ThemeSettings />
      </div>
    </div>
  );
};

export default ThemeSettingsPage;